import { asyncModule } from '../../utils/async-module';
import * as JSModules from '../../components/modules';

export const asyncELStreaming = () => {
  const $element = document.querySelector('.j-modal--europa-league');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.modalEuropaLeagueModule);
    start();
    import('../../components/europa-league-streaming/europa-league-streaming').then(getInit($element)).catch(error);
  }
};

export const asyncSectionEuroTvSchedule = () => {
  const $element = document.querySelector('.c-banner-text__content');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.euroTvScheduleModule);
    start();
    import('../../components/euro-tv-schedule/euro-tv-schedule').then(getInit()).catch(error);
  }
};
